// 指令相关接口
import request from '@/util/request'

export function orderActionControlSend (data) {
	// 控制指令下发
	return request({
		url: `/order-s/order/action/control/send`,
		method: 'post',
		data
	})
}
export function orderActionControlResend (orderId, data) {
	// 控制指令重发
	return request({
		url: `/order-s/order/action/resend/${orderId}`,
		method: 'post',
		data
	})
}

export function orderUpgradControlSend (data) {
	// 升级指令下发
	return request({
		url: `/order-s/order/action/upgrade/send`,
		method: 'post',
		data
	})
}

export function orderActionLast (param) {
	//查询最后一次执行指令
	return request({
		url: `/order-s/order/action/last`,
		method: 'get',
		params: param
	})
}

//查询指令状态
export function orderActionById (orderId) {
	return request({
		url: `/order-s/order/action/${orderId}`,
		method: 'get'
	})
}

export function orderListCode (productKey) {
	//获取当前设备的可控制的单个指令列表
	return request({
		url: `/order-s/order/manager/listCode/${productKey}`,
		method: 'get'
	})
}
export function apiGetAvailableOrder(productId,deviceId){
	//获取当前设备的可控制的指令总数据
	return request({
		url: `/order-s/order/manager/get-device-code/${productId}/${deviceId}`,
		method: 'get'
	});
}

// 操作审计
export function operationRecords (data) {
	return request({
		url: `/order-s/order/action/operationRecords`,
		method: 'post',
		data
	})
}

// 读写记录
export function readRecordList (data) {
	return request({
		url: `/order-s/order/action/readWriteRecords`,
		method: 'post',
		data
	})
}

// 升级记录
export function updateRecordList (data) {
	return request({
		url: `/order-s/order/action/upgradeRecords`,
		method: 'post',
		data
	})
}

// 当前版本信息
export function deviceOrderVersion (deviceId, params) {
	return request({
		url: `/order-s/order/action/device/${deviceId}/version`,
		method: 'get',
		params
	})
}

// 判断设备是否开通自定义命令
export function apiOpenStatus (productKey) {
	return request({
		url: `/order-s/order/manager/custom/openStatus/${productKey}`,
		method: 'get'
	})
}

// sim判断
export function simOrder (deviceId, params) {
	return request({
		url: `/order-s/order/action/check/sim/${deviceId}`,
		method: 'get',
		params
	})
}

// 升级重新下发
export function uResend (orderId, data) {
	return request({
		url: `/order-s/order/action/resend/${orderId}`,
		method: 'post',
		data
	})
}

// 组网列表
export function Getlist (data) {
	return request({
		url: `/order-s/order/action/network/list `,
		method: 'post',
		data
	})
}

//获取控制和解析配置
// import optionClass from "@/util/orderConfig/G1101.js";
// import rule1101 from "@/util/orderConfig/1101.js";
export function apiGetDeviceConfigOption(){
	let ver=window.deviceConfigOption?window.deviceConfigOption.lastVersion:undefined;
	let api=request({
		url:`/order-s/order/manager/static/rule`,
		method:'get',
		params:{ver}
	});
	api.then(success=>{
		if(success.versionChange){
			// success.rule.optionClass={};
			// $.extend(true,success.rule.optionClass,{G1101:optionClass});
			// $.extend(true,success.rule.option,{1101:rule1101.codeList});
			// success.rule.option["1013"]=rule1101.codeList;
			
			$.each(success.rule.optionClass,(name,groupClass)=>{//遍历所欲型号
				$.each(groupClass,(index,group)=>{//遍历型号下的所有小组
					group.cmdMap={};
					$.each(group.cmdList,(i,cmd)=>{//遍历所有小组内的指令，并进行索引
						group.cmdMap[cmd.code]=cmd;
					});
				});
			});
			window.deviceConfigOption=success;
			window.deviceConfigOption.loadTime=new Date().getTime();
		}
	});
	return api;
}

//获取批量控制每个小组的有效数据
export function apiGetBatchOrderLastData(deviceId){
	let api=request({
		url:`/order-s/order/action/last/batchParam/group`,
		method:'get',
		params:{deviceId}
	});
	return api;
}
//获取批量控制单个小组的有效数据
export function apiGetSingleOrderLastData(deviceId){
	let api=request({
		url:`/order-s/order/action/last/batchParam/single`,
		method:'get',
		params:{deviceId}
	});
	return api;
}



// WEBPACK FOOTER //
// ./src/api/device/order.js